module.exports = __webpack_public_path__ + "img/CTWP__Bow.aec1a2c4.png";